import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ApiContext } from '../../App';
import { Stack, Box, Typography, Card, CardContent, ToggleButtonGroup, ToggleButton, FormControl, Select, MenuItem, CardHeader } from '@mui/material';
import MonitoringChart from './components/MonitoringChart';
import MonitoringBanner from './components/MonitoringBanner';
import DateRangeSelector from '../../components/DateRangeSelector';
import { useLocation } from 'react-router-dom';

export default function MonitoringDashboard(props) {

    const { facility } = props;
    const { t } = useTranslation();
    const {readingsApi} = React.useContext(ApiContext)

    const [data, setData] = React.useState({});

    var earlierDate = new Date();
    earlierDate.setDate(earlierDate.getDate() - 2);
    const [fromDate, setFromDate] = React.useState(earlierDate);
    const [toDate, setToDate] = React.useState(new Date());
    const [timeAggType, setTimeAggType] = React.useState("h");
    const [dataAggType, setDataAggType] = React.useState("system");

    const handleAPIError = () => {
        window.alert(t("Problem fetching data."))
    }

    React.useEffect(() => {
        
        readingsApi.getTrends(
            facility,
            fromDate,
            toDate,
            data => {
                setData(data);
            },
            () => {
                setData({});
                handleAPIError();
            },
            timeAggType,
            {
                POWER_METER: `kwh_by_${dataAggType}`
            },
            [],
            [],
            [],
            [],
            [],
        )
    
    },
    [timeAggType, fromDate, toDate, dataAggType]
    )

    const handleTimeAggTypeChange = (event, newValue) => {
        setTimeAggType(newValue);
    }

    return (
        <Box sx={{
            backgroundColor: (theme) => theme.palette.grey[100]
        }}>
            <Stack spacing={2} padding={2}>
                <Stack direction="row">
                    <Card>
                        <CardContent>
                            <Stack direction="row" spacing={2}>
                                <DateRangeSelector
                                    fromDate={fromDate}
                                    toDate={toDate}
                                    onFromDateChange={(newDate) => setFromDate(newDate)}
                                    onToDateChange={(newDate) => setToDate(newDate)}
                                    small={true}
                                    hideTitle
                                />
                                <ToggleButtonGroup
                                    value={timeAggType}
                                    exclusive
                                    size="small"
                                    onChange={handleTimeAggTypeChange}
                                >
                                    <ToggleButton value="h">
                                        {t("H")}
                                    </ToggleButton>
                                    <ToggleButton value="d">
                                        {t("D")}
                                    </ToggleButton>
                                    <ToggleButton value="m">
                                        {t("M")}
                                    </ToggleButton>
                                    <ToggleButton value="q">
                                        {t("Q")}
                                    </ToggleButton>
                                    <ToggleButton value="y">
                                        {t("Y")}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                <FormControl sx={{ minWidth: 120 }} size="small">
                                    <Select value={dataAggType} onChange={(event)=>setDataAggType(event.target.value)}>
                                        <MenuItem value="location">
                                            {t("Location")}
                                        </MenuItem>
                                        <MenuItem value="system">
                                            {t("System")}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
                <MonitoringBanner data={data}/>
                <Card>
                    <CardContent >
                        <Box height="calc(100vh - 342px)">
                            <MonitoringChart timeAggType={timeAggType} data={data}/> :
                        </Box> 
                    </CardContent>
                </Card>
            </Stack>
        </Box>
    );


};